import type { PriceType } from "../priceType";
import { przezmorzeApi, throwMessageOnBadRequestStatus } from "../../../../api/api";

export interface DownloadCsvRequest {
  readonly providerId: string;
  readonly priceType: PriceType;
  readonly year: number;
}

export async function downloadCsvWithPrices(request: DownloadCsvRequest, abortSignal?: AbortSignal): Promise<Blob> {
  try {
    const response = await przezmorzeApi.get<Blob>(`/prices/export/${request.priceType}`, {
      signal: abortSignal,
      headers: { Accept: "application/csv" },
      params: { year: request.year, providerId: request.providerId },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}
